<template>
  <div v-show="showPreview">
    <div class="map" ref="map"></div>
  </div>
</template>

<script>
import center from '@turf/center';
import config from '../../config';
import Map from '../../services/map';
import PhotoStation from '../../services/photoStation';
import { parseGeoJSON } from '../../utils/map';
import { geostyleParcel, geostylePhotoStation } from '../../utils/geostyles';
export default {
  props: {
    geojson: {
      type: [String, Object],
      default: null
    },
    geolocation: {
      type: Object,
      default: null
    },
    orientation: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      map: new Map()
    };
  },
  computed: {
    showPreview() {
      return this.geojson && this.geolocation?.lng && this.orientation?.heading != null;
    }
  },
  mounted() {
    this.createMap();
  },
  watch: {
    geolocation: {
      handler: 'render',
      deep: true
    },
    orientation: {
      handler: 'render',
      deep: true
    }
  },
  methods: {
    createMap() {
      const geojson = parseGeoJSON(this.geojson);
      if (!geojson) {
        return;
      }
      const map = new Map({
        accessToken: config.mapboxToken,
        container: this.$refs.map,
        center: center(geojson).geometry.coordinates,
        zoom: 17
      });
      this.map = map;
      map.onLoad(() => {
        this.render();
      });
    },
    render() {
      setTimeout(() => {
        this.map.map.resize();
      }, 200);
      if (!this.map || !this.map.map) return;
      const geojson = parseGeoJSON(this.geojson);
      const ps = new PhotoStation();
      const data = [
        {
          orientation: this.orientation,
          geolocation: this.geolocation
        }
      ];

      ps.setImages(data);
      ps.setGeoJSON(geojson);

      ps.applyScaleFactor({ scale: 1 });
      this.map.add('parcel', 'GEOJSON', { geojson: Map.applyGeostyle(geojson, geostyleParcel) });
      ps.applyScaleFactor({ scale: 1 });
      this.map.add('photo-station', 'GEOJSON', {
        geojson: Map.applyGeostyle(ps.getGeoJSON(), geostylePhotoStation)
      });
    }
  }
};
</script>

<style scoped>
.map {
  height: 250px;
  width: 100%;
}
</style>
